export default {
  about_us: 'NOSOTROS',
  services: 'SERVICIOS',
  solutions: 'Soluciones',
  blog: 'BLOG',
  portfolio: 'PORTAFOLIO',
  contact: 'CONTACTO',
  footerMessage: 'Apok, C.A J-40065605-2 |   Todos los derechos reservados 2019',
  home: 'INICIO',
  notFound: 'La pagina que busca no puede ser localizada.',
  goHome: 'Ir a Inicio',
}



// WEBPACK FOOTER //
// ./src/i18n/es/home.js